<script setup lang="ts">
    import { FilterStoreName } from '@/js/services/api/filter/types';
    import { __ } from '@/js/stores/expressions';
    import {
        InteractionTableStoreName,
        useInteractionTableStoreByName,
    } from '@/js/stores/interactions-table';
    import { ref, watch } from 'vue';
    import AllFilters from '../../filter/AllFilters.vue';
    import CheckboxInput from '../../CheckboxInput.vue';
    import FavoriteFilters from '../../filter/FavoriteFilters.vue';
    import EchoButton from '../../EchoButton.vue';
    import ToggleSwitch from '../../ToggleSwitch.vue';
    import HeatMapLabel from '../HeatMapLabel.vue';
    import ActiveFiltersContainer from '../../filter/ActiveFiltersContainer.vue';
    import { useFilterWatch } from '@/js/composables/useFilterWatch';

    const allFiltersVisible = ref(false);
    const showAddFavoriteModal = ref(false);

    const { filterStore } = useFilterWatch(FilterStoreName.SharedFilter);

    const tableStore = useInteractionTableStoreByName(
        InteractionTableStoreName.OrganisationalTable
    );

    const submittedByMe = ref<boolean>(false);

    watch(submittedByMe, (newValue) => {
        if (filterStore.all) {
            filterStore.all.submittedByMe = newValue || null;
        }
    });
</script>
<template>
    <div class="flex w-full">
        <div class="w-0 grow">
            <div class="w-full">
                <div class="w-full flex pt-10">
                    <ActiveFiltersContainer
                        :filter-store-name="FilterStoreName.SharedFilter"
                        :all-filters-visible="allFiltersVisible"
                        match-table-padding
                    >
                        <template #save-filter>
                            <EchoButton
                                variant="primary"
                                size="small"
                                :title="__('favorite-filters-save')"
                                @click="showAddFavoriteModal = true"
                            >
                                {{ __('favorite-filters-save') }}
                            </EchoButton>
                        </template>
                        <template #favorite-filters>
                            <FavoriteFilters
                                v-model:show-add-modal="showAddFavoriteModal"
                                :filter-store-name="FilterStoreName.SharedFilter"
                            />
                        </template>
                    </ActiveFiltersContainer>
                </div>

                <div class="flex justify-between px-7.5 pb-4">
                    <div>
                        <!-- Knapp ska in här sen -->
                    </div>
                    <div class="flex flex-wrap items-center gap-10">
                        <CheckboxInput
                            id="coached-by-me"
                            v-model="submittedByMe"
                            :label="__('organisational-table-coached-by-me')"
                        >
                            <p class="text-body">
                                {{ __('organisational-table-coached-by-me') }}
                            </p>
                        </CheckboxInput>
                        <ToggleSwitch
                            v-model="tableStore.showCoachResultAsPoints"
                            :label="__('protocol-filter-points')"
                            :start-label="__('protocol-filter-percentage')"
                        />
                        <div class="flex gap-3 items-center">
                            <ToggleSwitch v-model="tableStore.showHeatMap">
                                <template #startLabel>
                                    <HeatMapLabel />
                                </template>
                            </ToggleSwitch>
                        </div>
                    </div>
                </div>
            </div>
            <div class="px-7.5 pb-7.5">
                <slot name="table" />
            </div>
        </div>
        <div class="relative shrink-0 z-30">
            <div class="top-0" :class="allFiltersVisible ? 'sticky w-80' : ''">
                <AllFilters
                    :filter-store-name="FilterStoreName.SharedFilter"
                    :is-visible="allFiltersVisible"
                    match-table-padding
                    @toggle-visibility="(visible) => (allFiltersVisible = visible)"
                />
            </div>
        </div>
    </div>
</template>
